export const FeatureFlags = Object.freeze({
  HIDE_PAUSE_BUTTON: true,
  DIGITAL_CALIBRATION_FLOW: false,
});
